import React from "react"
import { useTranslations } from "@/hooks/useTranslations"
import { ShieldOff, ExternalLink } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useAuth } from "@/hooks/useAuth"

const HUB_URL = "https://app.optimgov.es"

export const ModuleNotActiveScreen: React.FC = () => {
	const t = useTranslations("auth")
	const { logout } = useAuth()

	return (
		<div className='min-h-screen flex flex-col items-center justify-center bg-slate-100 px-4'>
			<div className='mb-8 flex items-center gap-3'>
				<img src='/OptimGovLogo.png' alt='OptimGov' width={220} height={50} className='h-16 w-auto' />
			</div>

			<div className='w-full max-w-md bg-white rounded-xl shadow-lg overflow-hidden'>
				<div className='bg-amber-500 px-6 py-4'>
					<div className='flex items-center justify-center gap-2 text-white'>
						<ShieldOff className='h-5 w-5' />
						<span className='font-medium'>{t("moduleNotActive")}</span>
					</div>
				</div>

				<div className='p-6 sm:p-8 text-center'>
					<p className='text-gray-700 mb-4'>{t("moduleNotActiveDescription")}</p>
					<p className='text-sm text-gray-500 mb-6'>{t("moduleNotActiveContact")}</p>

					<div className='space-y-3'>
						<Button asChild size='lg' className='w-full bg-primary hover:bg-brand-forest-start text-white'>
							<a href={HUB_URL}>
								<ExternalLink className='mr-2 h-4 w-4' />
								{t("moduleNotActiveHub")}
							</a>
						</Button>

						<Button variant='outline' size='lg' className='w-full' onClick={() => logout()}>
							{t("logout")}
						</Button>
					</div>
				</div>
			</div>

			<div className='mt-8 text-center'>
				<p className='text-sm text-gray-400'>
					&copy; {new Date().getFullYear()} OptimGov.
				</p>
			</div>
		</div>
	)
}
